import { useCallback, useEffect, useState } from 'react';

import crmOpportunityScheduleService from '../../domain/services/crm/crm.opportunity.schedule.service';

const useScheduleConfig = (isOpen) => {

    const [config, setConfig] = useState(null);
    const [status, setStatus] = useState('loading');

    const load = useCallback(() => {
        setStatus('loading');

        return crmOpportunityScheduleService
            .findScheduleConfig()
            .then(found => {
                setConfig(found);
                setStatus('ready');
            })
            .catch(() => setStatus('error'));
    }, []);

    useEffect(() => {
        if (isOpen)
            load();
    }, [isOpen, load]);

    return { config, status, reload: load };
}

export default useScheduleConfig;
